const disableUserInteractionHandler = function disableUserInteractionHandler(event) {
    event.stopPropagation();
    event.preventDefault();
};

export const loadingClassName = 'watch-loading';

export function uiLoadingStart() {
    if (process.browser) {
        const { body: { className } = {} } = document || {};
        document.body.className = `${className.replace(loadingClassName, '')} ${loadingClassName}`;
    }
}

export function uiLoadingComplete() {
    if (process.browser) {
        const { body: { className } = {} } = document || {};
        document.body.className = className.replace(loadingClassName, '');
        enableUserInteraction();
    }
}

export function disableUserInteraction() {
    if (process.browser) {
        ['click', 'touchstart'].forEach((eventName) => {
            document.body.addEventListener(eventName, disableUserInteractionHandler);
        })
    }
}

export function enableUserInteraction() {
    if (process.browser) {
        ['click', 'touchstart'].forEach((eventName) => {
            document.body.removeEventListener(eventName, disableUserInteractionHandler);
        })
    }
}



// WEBPACK FOOTER //
// ./app/lib/ui/loading.js